import ReactDOM from "react-dom/client";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { getMsalConfig } from "./authConfig";
import { ToastContainer } from "react-toastify";
import { LoadingProvider } from "./loading/LoadingContext";
import { CustomLoading } from "./loading/Loading";
import UserContextProvider from "./user/UserContext";
import App from "./App";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
// import reportWebVitals from './reportWebVitals'

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

const msalInstance = new PublicClientApplication(getMsalConfig("/"));

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
    <MsalProvider instance={msalInstance}>
      <QueryClientProvider client={queryClient}>
        <div className="p-0" style={{ fontSize: "16px" }}>
          <ReactQueryDevtools />
        </div>
        <LoadingProvider>
          <UserContextProvider>
            <App />
          </UserContextProvider>
          <CustomLoading />
        </LoadingProvider>
      </QueryClientProvider>
      <ToastContainer />
    </MsalProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
